export default {"theme":{"themes":{"light":{"primary":"#2D9C4E","accent":"#607C9C","secondary":"#607C9C","info":"#7B4C1F","warning":"#BC3131","error":"#BC3131","success":"#2FBC7B"}},"options":{"customProperties":true}}}
